import * as React from 'react';
import { CSSTransition } from 'react-transition-group';
import { TooltipValueContext, TooltipUpdaterContext, useTooltip } from '../../utils/tooltop';
import { useWindowSize } from '../../utils/windowSize';

const WINDOW_PADDING = 10;
const TOOLTIP_MAXWIDTH = 320;

export const TooltipUpdaterConsumer = TooltipUpdaterContext.Consumer;

// eslint-disable-next-line react/prop-types
export const TooltipProvider = ({ children }) => {
  const [valueState, updaterState] = useTooltip();

  return (
    <TooltipValueContext.Provider value={valueState}>
      <TooltipUpdaterContext.Provider value={updaterState}>
        {children}
      </TooltipUpdaterContext.Provider>
    </TooltipValueContext.Provider>
  );
};

const Tooltip = () => {
  const { isShow, top, left, item, opts } = React.useContext(TooltipValueContext);
  const { clearTooltip } = React.useContext(TooltipUpdaterContext);
  const [ isPCView, setIsPCView ] = React.useState(false);

  const windowSize = useWindowSize();

  React.useEffect(() => {
    const pcView = windowSize.width > 1200;
    setIsPCView(pcView);
  }, [windowSize]);

  const maxWidth = Math.min(
    ((left < window.innerWidth / 2) ?
      (left - WINDOW_PADDING) * 2 :
      (window.innerWidth - left - WINDOW_PADDING) * 2), TOOLTIP_MAXWIDTH);

  return (
    <CSSTransition
      in={isShow}
      unmountOnExit={true}
      timeout={300}
      classNames={{
        enter: 'enter',
        enterActive: 'enterActive',
        exit: 'exit',
        exitActive: 'exitActive',
      }}
    >
      <div
        style={{
          top: `${top}px`,
          left: `${isPCView ? left : 220}px`,
          maxWidth: isPCView ? `${maxWidth}px` : undefined,
        }}
        className="tooltipOuter"
        onMouseLeave={clearTooltip}
        onTouchStart={e => {
          e.stopPropagation();

          if (opts && opts.clearOnTap) {
            clearTooltip();
          }
        }}
      >
        <div className="tooltipContents">
          {item}
        </div>
      </div>
    </CSSTransition>
  );
};

export default Tooltip;
